/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import ToggleBtn from "../SidebarComponent/ToggleBtn/ToggleBtn";
import "./Nav.css";
import { useNavigate } from "react-router";
// import { logoutUser } from "../../services/auth/AuthAPI";

function AuthNav(props: any) {
  const location = window.location.pathname;
  const user = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("userData")))).idToken.payload;
  const navigate = useNavigate();
  const [active, setActive] = React.useState(location);
  return (
    <nav className="navbar navbar-expand-lg  position-sticky top-0">
      <div className="container-fluid d-flex align-items-center px-4 py-2">
        <ToggleBtn />
        <a
          className="navbar-brand "
          href="/auth">
          <img
            src={require("../../assets/img/william_lea_small.png")}
            alt=""
          />
        </a>

        <div
          className="collapse navbar-collapse justify-content-between  "
          id="navbarNavAltMarkup">
          <div className="d-flex gap-3">
            <div className="navbar-nav gap-3 ">
              <div className="nav-item">
                <button
                  className={`nav-link ${active.includes("single-search") ? "active" : ""} `}
                  onClick={() => {
                    navigate("single-search");
                    setActive("single-search");
                  }}>
                  <div className="d-flex align-items-center gap-1">
                    {/* <span className="material-symbols-outlined">person</span> */}
                    <span>Single Search</span>
                    {/* <span className="material-symbols-outlined">arrow_drop_down</span> */}
                  </div>
                </button>
              </div>
            </div>
            <div className="navbar-nav gap-3 ">
              <div className="nav-item">
                <button
                  className={`nav-link ${active.includes("bulk-search") ? "active" : ""} `}
                  onClick={() => {
                    navigate("bulk-search");
                    setActive("bulk-search");
                  }}>
                  <div className="d-flex align-items-center gap-1">
                    {/* <span className="material-symbols-outlined">person</span> */}
                    <span>Bulk Search</span>
                    {/* <span className="material-symbols-outlined">arrow_drop_down</span> */}
                  </div>
                </button>
              </div>
            </div>
          </div>

          <div className="dropdown">
            <button
              className="user-container  "
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              <div className="d-flex align-items-center gap-1">
                <span className="material-symbols-outlined">person</span>
                <span>{user.name}</span>
                <span className="material-symbols-outlined">arrow_drop_down</span>
              </div>
            </button>

            <div
              className="dropdown-menu drop-menu-container "
              aria-labelledby="dropdownMenuButton">
              <a
                className="dropdown-item dropdown-item-customize"
                onClick={() => console.log("logout")}
                href="/">
                Logout
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default AuthNav;
